import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import PaymentForm from "./payment-form"
import PaymentTable from "./payment-table"
import { useSelector } from "react-redux"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

export default function Payment() {
  const { userRole } = useSelector(userData)
  const [create, setCreate] = useState(false)
  const [view, setView] = useState(false)
  const [paymentData, setPaymentData] = useState({})
  const [updateId, setUpdateId] = useState()

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  useEffect(() => {
    const handlePopState = event => {
      setUpdateId()
      setPaymentData({})
      setCreate(false)
      setView(false)
      window.history.pushState(null, null, window.location.href)
    }

    window.history.pushState(null, null, window.location.href)
    window.addEventListener("popstate", handlePopState)
    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [])

  const pickPaymentData = payment_data => ({
    id: payment_data?.id,
    scholarshipFinanceDataId: payment_data?.scholarshipFinanceDataId
      ? payment_data?.scholarshipFinanceDataId
      : "",
    currentYear: payment_data?.currentYear ? payment_data?.currentYear : "",
    currentSemester: payment_data?.currentSemester
      ? payment_data?.currentSemester
      : "",
    isPaid: payment_data?.isPaid ? payment_data?.isPaid : false,
    amountPaid: payment_data?.amountPaid ? payment_data?.amountPaid : "",
    paymentModeEnum:
      payment_data?.paymentModeEnum === null ||
      payment_data?.paymentModeEnum === undefined
        ? ""
        : payment_data?.paymentModeEnum,
    firstPaymentDueDate: payment_data?.firstPaymentDueDate
      ? payment_data?.firstPaymentDueDate?.slice(0, 10)
      : "",
    paymentMadeDate: payment_data?.paymentMadeDate
      ? payment_data?.paymentMadeDate?.slice(0, 10)
      : "",
    year: payment_data?.year ? payment_data?.year : "",
    month: payment_data?.month ? payment_data?.month : "",
    challanNumber: payment_data?.challanNumber
      ? payment_data?.challanNumber
      : "",
  })

  const forUpdate = payment_data => {
    setUpdateId(payment_data.id)
    setPaymentData(pickPaymentData(payment_data))
    setView(false)
    setCreate(true)
  }

  const forView = payment_data => {
    setUpdateId(payment_data.id)
    setPaymentData(pickPaymentData(payment_data))
    setView(true)
    setCreate(true)
  }

  const toggleTab = () => {
    setUpdateId()
    setPaymentData({})
    setView(false)
    setCreate(!create)
  }

  return (
    <div className="">
      {/* {!isViewer && (
        <Row className="mb-2">
          <Col className="justify-content-end d-flex">
            <button className="switch-btn" onClick={toggleTab}>
              {create ? "View" : "Create"}
            </button>
          </Col>
        </Row>
      )} */}
      {create ? (
        <PaymentForm
          paymentData={paymentData}
          updateId={updateId}
          view={view}
          toggleTab={toggleTab}
        />
      ) : (
        <PaymentTable forUpdate={forUpdate} forView={forView} />
      )}
    </div>
  )
}
